<template>
  <div class="position-absolute top-0 start-0 p-3">
    <img
      alt="Logo"
      src="@/assets/logo.png"
      class="logo"
      style="height: 60px; width: auto"
    />
  </div>
  <div
    v-if="userInfo"
    class="position-fixed top-0 start-50 translate-middle-x p-3 nav-dropdown-container"
  >
    <BDropdown ref="navigationDropdown" variant="outline-dark" no-caret>
      <template #button-content>
        <IconMenu2 :size="20" />
      </template>
      <BDropdownItem @click="navigateTo('/transactions')">
        Transactions Dashboard
      </BDropdownItem>
      <BDropdownItem @click="navigateTo('/weekly-outlooks')">
        Weekly Outlook
      </BDropdownItem>
      <BDropdownItem
        v-if="userInfo.username === 'javesparza'"
        @click="navigateTo('/monthly-overview')"
      >
        Monthly Overview
      </BDropdownItem>
      <BDropdownItem
        v-if="userInfo.username === 'javesparza'"
        @click="navigateTo('/accounts')"
      >
        Accounts Management
      </BDropdownItem>
      <BDropdownItem
        v-if="userInfo.username === 'javesparza'"
        @click="navigateTo('/banking-institutions')"
      >
        Banking Institutions Management
      </BDropdownItem>

      <div
        v-if="userInfo.username === 'javesparza'"
        class="dropdown-submenu-container"
      >
        <button
          type="button"
          class="dropdown-item dropdown-submenu-toggle d-flex align-items-center justify-content-between"
          @click.stop="toggleBudgetMenu"
        >
          <span>Budget Management</span>
          <IconChevronRight
            :size="16"
            class="dropdown-submenu-icon"
            :class="{ 'is-open': showBudgetMenu }"
          />
        </button>

        <div v-if="showBudgetMenu" class="dropdown-submenu-items">
          <button
            type="button"
            class="dropdown-item dropdown-submenu-item"
            @click="navigateToBudgetSection('templates')"
          >
            Budget Templates
          </button>
          <button
            type="button"
            class="dropdown-item dropdown-submenu-item"
            @click="navigateToBudgetSection('tracking')"
          >
            Tracking
          </button>
        </div>
      </div>
    </BDropdown>
  </div>
  <div class="position-fixed top-0 end-0 p-3">
    <SignOutButton v-if="userInfo" />
  </div>
</template>
<script>
import { BDropdown, BDropdownItem } from "bootstrap-vue-next";
import { IconChevronRight, IconMenu2 } from "@tabler/icons-vue";
import SignOutButton from "@/components/atoms/SignOutButton.vue";
// Import Vuex store namespaces
import { userSession as userSessionNS } from "@/store/namespaces.js";

export default {
  name: "AppHeader",
  components: {
    BDropdown,
    BDropdownItem,
    IconChevronRight,
    IconMenu2,
    SignOutButton,
  },
  data() {
    return {
      showBudgetMenu: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters[`${userSessionNS}/getUserInfo`];
    },
  },
  methods: {
    isSameRoute(target) {
      const resolvedRoute = this.$router.resolve(target);

      return (
        this.$route.path === resolvedRoute.path &&
        JSON.stringify(this.$route.query) ===
          JSON.stringify(resolvedRoute.query)
      );
    },
    closeMenus() {
      this.showBudgetMenu = false;
      this.$refs.navigationDropdown?.hide?.();
    },
    navigateTo(target) {
      if (this.isSameRoute(target)) {
        this.closeMenus();
        return;
      }

      this.closeMenus();
      this.$router.push(target);
    },
    navigateToBudgetSection(section) {
      if (section === "templates") {
        this.navigateTo({ path: "/budget/templates" });
        return;
      }

      if (section === "tracking") {
        this.navigateTo({ path: "/budget/tracking" });
        return;
      }

      this.navigateTo({ path: "/budget/templates" });
    },
    toggleBudgetMenu() {
      this.showBudgetMenu = !this.showBudgetMenu;
    },
  },
};
</script>

<style scoped>
.nav-dropdown-container {
  z-index: 1200;
}

.dropdown-submenu-container {
  min-width: 14rem;
}

.dropdown-submenu-toggle {
  width: 100%;
}

.dropdown-submenu-items {
  padding-bottom: 0.25rem;
}

.dropdown-submenu-item {
  padding-left: 2rem;
}

.dropdown-submenu-icon {
  transition: transform 0.2s ease;
}

.dropdown-submenu-icon.is-open {
  transform: rotate(90deg);
}
</style>
